import { c as _c } from "react/compiler-runtime";
import { colors, DetailCard, EmployeesRow, Text } from '@newfront-insurance/core-ui';
import type { DetailCardProps } from '@newfront-insurance/core-ui';
import * as React from 'react';
import type { JSX } from 'react';
import { AccountDefinitions } from './account-definitions';
import type { AccountCardAccount, AccountCardPublicAccount } from './lib';
import { isPublicAccount } from './lib';
export * from './lib';
interface Props extends Pick<DetailCardProps, 'actions' | 'badgeProps' | 'cardProps' | 'defaultExpanded' | 'eyebrowProps' | 'isExpandable' | 'isHighlighted' | 'isHovering' | 'selectableOptions'> {
  account: AccountCardAccount | AccountCardPublicAccount;
  /**
   * Use the useEmployees hook from admin-ui to get this value.
   */
  servicingTeam?: Pick<React.ComponentProps<typeof EmployeesRow>, 'employees'>['employees'];
  onCopyEmployeeEmail?: () => void;
  withProgramType?: boolean;
}
export function AccountCard(t0) {
  const $ = _c(19);
  const {
    account,
    actions,
    isHighlighted,
    defaultExpanded,
    isExpandable: t1,
    onCopyEmployeeEmail,
    servicingTeam,
    cardProps,
    selectableOptions,
    badgeProps,
    eyebrowProps,
    isHovering,
    withProgramType
  } = t0;
  const isExpandable = t1 === undefined ? false : t1;
  const dba = isPublicAccount(account) ? account.dba : account.details.dba;
  let subtitle = dba;
  if (withProgramType && account.readableProgramType) {
    subtitle = `${account.readableProgramType}`;
    if (dba) {
      subtitle = subtitle + ` - ${dba}`;
    }
  }
  let t2;
  if ($[0] !== account) {
    t2 = <AccountDefinitions account={account} />;
    $[0] = account;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== onCopyEmployeeEmail || $[3] !== servicingTeam) {
    t3 = servicingTeam && <div className="flex flex-col gap-2"><Text size="small" color={colors.steel[400]}>Servicing team</Text><div className="flex flex-row gap-1"><EmployeesRow employees={servicingTeam} variant="expanded" onCopyEmail={onCopyEmployeeEmail} /></div></div>;
    $[2] = onCopyEmployeeEmail;
    $[3] = servicingTeam;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== account.name || $[6] !== actions || $[7] !== badgeProps || $[8] !== cardProps || $[9] !== defaultExpanded || $[10] !== eyebrowProps || $[11] !== isExpandable || $[12] !== isHighlighted || $[13] !== isHovering || $[14] !== selectableOptions || $[15] !== subtitle || $[16] !== t2 || $[17] !== t3) {
    t4 = <DetailCard title={account.name} subtitle={subtitle} isHighlighted={isHighlighted} isHovering={isHovering} defaultExpanded={defaultExpanded} isExpandable={isExpandable} cardProps={cardProps} selectableOptions={selectableOptions} actions={actions} badgeProps={badgeProps} eyebrowProps={eyebrowProps}>{t2}{t3}</DetailCard>;
    $[5] = account.name;
    $[6] = actions;
    $[7] = badgeProps;
    $[8] = cardProps;
    $[9] = defaultExpanded;
    $[10] = eyebrowProps;
    $[11] = isExpandable;
    $[12] = isHighlighted;
    $[13] = isHovering;
    $[14] = selectableOptions;
    $[15] = subtitle;
    $[16] = t2;
    $[17] = t3;
    $[18] = t4;
  } else {
    t4 = $[18];
  }
  return t4;
}